import $store from '@/store'

export default [
  {
    name: 'loan/fast-loan-300-intro',
    path: '/loan/fast-loan-300-intro',
    meta: { design: { classes: ['px-0'] } },
    component: () => import('@/pages/loan/FastLoan300Intro.vue'),
  },
  {
    name: 'loan/fast-loan-300',
    path: '/loan/fast-loan-300',
    meta: { design: { classes: ['px-0'] } },
    component: () => import('@/pages/loan/FastLoan300.vue'),
  },
  {
    name: 'loan/metarich',
    path: '/loan/metarich',
    meta: { design: { classes: ['px-0'] } },
    component: () => import('@/pages/loan/Metarich.vue'),
  },
  {
    name: 'loan/fast-loan-300-check',
    path: '/loan/fast-loan-300-check',
    meta: { design: { classes: ['px-0'] } },
    component: () => import('@/pages/loan/FastLoan300Check.vue'),
  },
  {
    name: 'loan/fast-loan-300-wait',
    path: '/loan/fast-loan-300-wait',
    meta: { design: { classes: ['px-0'] } },
    component: () => import('@/pages/loan/FastLoan300Wait.vue'),
  },
  {
    name: 'loan/pull-revenue-intro',
    path: '/loan/pull-revenue-intro',
    meta: { design: { classes: ['px-0'] } },
    component: () => import('@/pages/loan/PullRevenueIntro.vue'),
  },
  {
    name: 'loan/pull-revenue',
    path: '/loan/pull-revenue',
    meta: { design: { classes: ['px-0'] } },
    component: () => import('@/pages/loan/PullRevenue.vue'),
  },
  {
    name: 'loan/pull-revenue-manage',
    path: '/loan/pull-revenue-manage',
    meta: { design: { classes: ['px-0'] } },
    component: () => import('@/pages/loan/PullRevenueManage.vue'),
  },
  {
    name: 'loan/pull-revenue-check',
    path: '/loan/pull-revenue-check',
    meta: { design: { classes: ['px-0'] } },
    component: () => import('@/pages/loan/PullRevenueCheck.vue'),
  },
  {
    name: 'loan/detail',
    path: '/loan/:uuid',
    meta: { design: { classes: ['bg--linear-gradient'] } },
    component: () => import('@/pages/loan/Detail.vue'),
  },
  {
    name: 'loan/investing',
    path: '/loan/:uuid/investing',
    meta: { design: { classes: ['px-0'] } },
    component: () => import('@/pages/loan/Investing.vue'),
  },
  {
    name: 'loan/repayment',
    path: '/loan/:uuid/repayment',
    meta: { design: { classes: ['px-0'] } },
    component: () => import('@/pages/loan/Repayment.vue'),
  },
  {
    name: 'loan/contract',
    path: '/loan/:uuid/contract',
    meta: { design: { classes: ['px-0'] } },
    component: () => import('@/pages/loan/Contract.vue'),
    beforeEnter: async (to, from, next) => {
      // TODO 테스트시 진입 검사 무시 용도
      // if (['local', 'development'].includes(process.env.NODE_ENV)) {
      //   return next()
      // }

      // 계약서 작성 가능한지 검사
      const home = { name: 'earlypay' }
      const [loan, agreements] = await Promise.all([
        $store.dispatch('loan/getLoansDetail', to.params.uuid),
        $store.dispatch('agreement/getContractAgreements'),
      ])

      if (!loan) {
        next(home)
        return
      }

      console.log('loan.uuid, status ', loan.uuid, loan.status)

      // 대출 상태 검사
      if (loan.status !== 'invested') {
        await window.$swal.basic.alert('계약서를 작성 가능한 상태가 아닙니다.')
        next(home)
        return
      }

      // 이미 작성된 계약서가 있는지 검사
      const contract = agreements.find(
        (item) =>
          item.term.code === 'LIMIT_TRANSACTION' &&
          item.isAgreed === true &&
          item.offer?.uuid === loan.offer.uuid,
      )
      if (contract) {
        try {
          await $store.dispatch('loan/executeLoan', loan.uuid)
          await window.$swal.basic.alert('이미 작성된 계약서가 존재하여 대출이 실행됩니다.')
        } catch (error) {
          await window.$swal.basic.alert('대출 실행 중 오류가 발생했습니다. 잠시 후 다시 시도해주세요.')
        }
        next(home)
        return
      }

      next()
    },
  },
]
